import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Início', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Atuação', href: '#atuacao' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0C3A22] shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://storage.readdy-site.link/project_files/66d90ef2-528e-4451-823d-a1eab56ea0b6/8877739b-eaeb-4a42-9522-eb394f9d4bf0_erasebg-transformed.png?v=b2a00aa3046b2995abfdefea9bf1f914"
            alt="Bruno Castro Advocacia"
            className="h-[74px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-white/80 hover:text-[#C7A76C] transition-colors duration-300 text-sm font-sans font-medium tracking-wide cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Social Icons */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="https://wa.me/5511958814422"
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label="WhatsApp"
            className="w-9 h-9 flex items-center justify-center text-white/80 hover:text-[#C7A76C] transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
          </a>
          <a
            href="https://www.instagram.com/brunocastro_adv/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label="Instagram"
            className="w-9 h-9 flex items-center justify-center text-white/80 hover:text-[#C7A76C] transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-instagram-line text-2xl"></i>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white p-2 cursor-pointer"
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-400 overflow-hidden bg-[#0C3A22] ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col px-6 pb-6 pt-2 gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-white/80 hover:text-[#C7A76C] transition-colors duration-200 text-base font-sans font-medium cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.me/5511958814422"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center justify-center gap-2 bg-[#C7A76C] text-[#0C3A22] text-sm font-sans font-semibold px-5 py-3 rounded-md mt-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Fale com um especialista
          </a>
        </nav>
      </div>
    </header>
  );
}
